import { useMemo } from 'react'
import type { SortOption } from '@/types/filters'

interface SortSelectProps {
  value: SortOption
  onChange: (value: SortOption) => void
  showRelevance?: boolean
}

const baseSortOptions: { value: SortOption; label: string }[] = [
  { value: 'newest', label: 'Newest First' },
  { value: 'oldest', label: 'Oldest First' },
  { value: 'price-low', label: 'Price: Low to High' },
  { value: 'price-high', label: 'Price: High to Low' },
  { value: 'ending-soon', label: 'Ending Soon' },
]

const relevanceOption: { value: SortOption; label: string } = {
  value: 'relevance',
  label: 'Most Relevant',
}

export function SortSelect({ value, onChange, showRelevance = false }: SortSelectProps) {
  const sortOptions = useMemo(() => {
    if (showRelevance) {
      return [relevanceOption, ...baseSortOptions]
    }
    return baseSortOptions
  }, [showRelevance])

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as SortOption)}
      className="input w-auto"
    >
      {sortOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}
